import { AccordionItemTypes, Accordion } from "@components/Accordion";
import React from "react";

import { ContactUsLink, Link } from "src/components/Link";

export const NonprofitSearchFaqList = () => {
  const faqDataList: AccordionItemTypes[] = [
    {
      id: "find",
      title: "Can`t find your nonprofit?",
      description: (
        <React.Fragment>
          <p>
            Try searching by your organization’s EIN. If you know your nonprofit
            has gone through a name change, the profile might be under the older
            name. If your organization is new, it may not yet be in our
            database. We can add new organizations upon request.
          </p>
          <p>
            For further assistance or to request an addition, please{" "}
            <ContactUsLink />.
          </p>
        </React.Fragment>
      ),
    },
    {
      id: "sponsored",
      title: "Are you a fiscally sponsored project?",
      description: (
        <p>
          Fiscally sponsored projects are able to use Every.org, but may not
          have an established profile yet. Please <ContactUsLink /> and connect
          us to your point of contact at your fiscal sponsor so we can help get
          you set up!
        </p>
      ),
    },
    {
      id: "international",
      title: "Are you located outside the US?",
      description: (
        <React.Fragment>
          <p>Our database only consists of 501(c)(3) US organizations.</p>
          <p>
            For us to be able to make grants to non-US charities, they must
            either have a US entity with a 501(c)(3) status, a US fiscal
            sponsor, or an Equivalency Determination (ED). Learn more{" "}
            <Link
              data-tname="nonproftSearch__FAQ"
              to="https://support.every.org/hc/en-us/articles/1500007823522-We-don-t-have-501-c-3-status-how-can-I-get-on-Every-org-"
            >
              here
            </Link>
            .
          </p>
          <p>
            If you have any of the above items, please <ContactUsLink /> so we
            can create a profile for you!
          </p>
        </React.Fragment>
      ),
    },
  ];

  return <Accordion dataList={faqDataList} />;
};
